import { observer } from "mobx-react";
import { ManufactureItemOption } from "../../../../../data/model/manufacture/ManufactureItemOption";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { ManufactureItemOptionRadioSelector } from "./CommonComponents";
import Helper from "../../../../../module/Helper";
import ManufactureItem from "../../../../../data/model/manufacture/ManufactureItem";
import FormUtil from "../../../../../module/FormUtil";

export interface ManufacturePresetInfoFormProps {
    presetItemOptions: ManufactureItemOption;
    onAdd: () => void;
    onGenerate: () => void;
}

const ManufactureBTSeqPresetInfoForm: React.FC<ManufacturePresetInfoFormProps> = (props) => {
    const itemOptions = props.presetItemOptions;
    const onGenerate = props.onGenerate;
    const onAdd = props.onAdd;
    const readonly = false;

    return (
        <>
            <Grid container >
                <Grid container style={{ marginBottom: 10 }} spacing={2}>
                    <Grid item xl sm md>
                        <TextField
                            value={itemOptions.numberPerQty || ""}
                            name="numberPerQty"
                            type='number'
                            fullWidth
                            InputProps={{ readOnly: itemOptions.readonly }}
                            margin='normal'
                            label={FormUtil.getFieldLabel("numberPerQty")}
                            helperText={
                                Helper.getErrorText(itemOptions.errors?.numberPerQty)
                            }
                            error={
                                Helper.getErrorState(itemOptions.errors?.numberPerQty)
                            }
                            onChange={itemOptions.onChangeDefault}
                        />
                    </Grid>
                    <Grid item xl sm md>
                        <FormControl
                            fullWidth
                            margin='normal'>
                            <InputLabel id="unit">
                                {FormUtil.getFieldLabel("unit")}
                            </InputLabel>
                            <Select
                                fullWidth
                                disabled={itemOptions.readonly}
                                error={
                                    Helper.getErrorState(
                                        itemOptions.errors?.unit
                                    )
                                }
                                labelId="unit"
                                onChange={(e) => itemOptions.unit = e.target.value as any}
                                value={itemOptions.unit}
                                name="unit">
                                {Object.keys(ManufactureItem.UnitList).map((v, i) => (
                                    <MenuItem key={`unitKey${i}`} value={v}>{(ManufactureItem.UnitList as any)[v]}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xl sm md>
                        <TextField
                            value={itemOptions.qty || ""}
                            name="qty"
                            type='number'
                            fullWidth
                            InputProps={{ readOnly: itemOptions.readonly }}
                            margin='normal'
                            label={FormUtil.getFieldLabel("qty")}
                            helperText={
                                Helper.getErrorText(itemOptions.errors?.qty)
                            }
                            error={
                                Helper.getErrorState(itemOptions.errors?.qty)
                            }
                            onChange={itemOptions.onChangeDefault}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xl lg sm md>
                        <ManufactureItemOptionRadioSelector
                            optionKey="packagingType1"
                            value={itemOptions?.packagingType1}
                            selections={[
                                {
                                    label: "Plate",
                                    value: "plate"
                                },
                                {
                                    label: "Tube",
                                    value: "tube"
                                },
                            ]}
                            title="BT001 Packaging Type"
                            disabled={readonly}
                            error={itemOptions?.errors.packagingType1.isError}
                            errorText={itemOptions?.errors.packagingType1.errorText}
                            onValueChange={itemOptions?.onChangeOptionValue}
                        />
                    </Grid>
                    <Grid item xl lg sm md>
                        <ManufactureItemOptionRadioSelector
                            optionKey="packagingType2"
                            value={itemOptions?.packagingType2}
                            selections={[
                                {
                                    label: "Plate",
                                    value: "plate"
                                },
                                {
                                    label: "Tube",
                                    value: "tube"
                                },
                            ]}
                            title="BT002 Packaging Type"
                            disabled={readonly}
                            error={itemOptions?.errors.packagingType2.isError}
                            errorText={itemOptions?.errors.packagingType2.errorText}
                            onValueChange={itemOptions?.onChangeOptionValue}
                        />
                    </Grid>
                    <Grid item xl lg sm md>
                        <ManufactureItemOptionRadioSelector
                            optionKey="btseqIndexType"
                            value={itemOptions?.btseqIndexType}
                            selections={[
                                {
                                    label: "Single Plate Index",
                                    value: "singlePlateIndex"
                                },
                                {
                                    label: "Multiple Plate Index",
                                    value: "multiplePlateIndex"
                                },
                            ]}
                            title="BT003 Packaging Type"
                            disabled={readonly}
                            error={itemOptions?.errors.btseqIndexType.isError}
                            errorText={itemOptions?.errors.btseqIndexType.errorText}
                            onValueChange={itemOptions?.onChangeOptionValue}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }} spacing={1}>
                <Grid item>
                    <Button
                        onClick={onGenerate}
                        color='primary'
                        variant='contained'>생성</Button>
                </Grid>
                <Grid item>
                    <Button
                        onClick={onAdd}
                        color='primary'
                        variant='contained'>추가</Button>
                </Grid>
            </Grid>
            <hr />
        </>
    )
}

export default observer(ManufactureBTSeqPresetInfoForm);